const BASE_URL = `${process.env['NEXT_PUBLIC_API_BASE_URL']}api`;

const prepareRequest = async (
  requestInit: RequestInit
): Promise<RequestInit> => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const option: RequestInit = {
    ...requestInit,
    mode: 'cors',
    headers,
  };
  return option;
};

export async function apiRoutesFetch<T>(
  endpoint: string,
  requestInit: RequestInit
): Promise<T> {
  try {
    const requestOptions = await prepareRequest(requestInit);
    const result = await fetch(BASE_URL + endpoint, requestOptions);
    const json = await result.json();
    return result.ok
      ? (json as T)
      : Promise.reject({
          message: json.error,
          status: result.status,
        });
  } catch (error) {
    throw error;
  }
}
